export function generatedCallbackPath(scheme: string): string {
  const slug = scheme
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9-]/g, '');
  return slug ? `signin-oidc-${slug}` : '';
}

export const isValidCallbackPath = (path: string) => /^[A-Za-z0-9-]+$/.test(path);

export const stripSlashes = (path: string | null | undefined) => (path ?? '').replace(/\//g, '');

export function redirectUri(identityBaseUrl: string | null | undefined, path: string): string | null {
  if (!identityBaseUrl || !path) return null;
  return `${identityBaseUrl.replace(/\/$/, '')}/${stripSlashes(path)}`;
}
